<template>
    <div id="app">
        <GlobalLoading v-if="isLoading"></GlobalLoading>
        <Header/>
        <transition name="fade" mode="out-in">
            <router-view :key="$route.fullPath"></router-view>
        </transition>
        <Agreement />
    </div>
</template>

<script>
	import {Modal, Message} from 'ant-design-vue';
	import Header from './components/Header';
	import {mapState} from "vuex";
	import GlobalLoading from './components/GlobalLoading.vue';
	import Agreement from './components/Agreement.vue';

	export default {
		mounted() {
            Message.config({
				maxCount: 1
            });
            const pathname = location.pathname;
            if (pathname.indexOf('/en') === 0 || pathname.indexOf('/reg/en') === 0) {
	            this.$store.dispatch('main/changeLanguage', 'en');
            } else {
	            this.$store.dispatch('main/changeLanguage', 'zh');
            }
			this.$store.dispatch('main/getCurrentUser');
		},
		components: {
			Header,
			GlobalLoading,
			Agreement
        },
		computed: {
			...mapState({
				isLoading: state => state.main.isLoading,
				messageConfig: state => state.main.messageConfig,
				alertConfig: state => state.main.alertConfig
			})
		},
		watch: {
			alertConfig: function (newVal) {
				Modal[newVal.type]({
					title: newVal.message,
					okText: '确认',
					onOk() {
					},
				});
			},
			messageConfig: function (newVal) {
				Message[newVal.type](newVal.message, 2);
			}
		}
	};
</script>

<style lang="less">
    @import "./assets/less/index";
</style>
